import { CopyButton, Notice } from "@/components/tool-kit/primitives";
import {
  BUTTON_SMALL,
  RESULT_CARD,
  WIDGET_H3,
} from "@/components/tool-kit/styles";

/**
 * Filled sentence frames, each with a heading, a "use this" button, and Copy. Every
 * word comes in as a prop; `frames` is empty until the form has what a frame needs.
 */
export function FrameList({
  frames,
  labels,
  intro,
  need,
  useLabel,
  copyLabel,
  copiedLabel,
  onUse,
}: {
  frames: readonly string[];
  labels: readonly string[];
  intro: string;
  need: string;
  useLabel: string;
  copyLabel: string;
  copiedLabel: string;
  onUse: (frame: string) => void;
}) {
  if (frames.length === 0) {
    return <Notice>{need}</Notice>;
  }
  return (
    <div className="space-y-3">
      <p className="text-muted-foreground text-sm">{intro}</p>
      {frames.map((frame, index) => (
        <div
          className={`${RESULT_CARD} space-y-2`}
          key={labels[index] ?? frame}
        >
          <h3 className={WIDGET_H3}>{labels[index]}</h3>
          <p className="text-foreground text-sm leading-relaxed">{frame}</p>
          <div className="flex flex-wrap gap-2">
            <button
              className={BUTTON_SMALL}
              onClick={() => onUse(frame)}
              type="button"
            >
              {useLabel}
            </button>
            <CopyButton
              copiedLabel={copiedLabel}
              label={copyLabel}
              small
              text={frame}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
